import i18n from "@/i18n";
import store from "@/store";
import { SignJWT } from 'jose';
import {getAdditionalInformation} from "@/store/services/picklist";
import { getGatheringProcessFromOrder } from "@/store/services/task/actions/order/completePreconditionsService";
import { checkFormatDate, formatDateLocale } from "@/utils/configuration/formatters-config";
import {FileContent, taskCOMPLETEPRECONDITIONSMapping, taskCOMPLETEPRECONDITIONSMappingGEMY} from "@/types";
import {UON, connectedUserconfigurationEnv, deepClone, deleteNonRequiredAttributes, getEntity} from "@/utils";
import moment, { locale } from "moment";
import Notify from 'quasar/src/plugins/Notify.js';;
import { getProcess,  getRequiredDocumentValidatedByBR } from "@/store/services/task/actions/uploadDocumentService";
import { moveDocument, removeReceivedFile } from "@/store/services/order/orderApi";
import { downloadFile } from "@/store/services/offerService";
import { deleteReceivedFile } from "./gathering-process";
import { concatFile } from "@/store/services/configuration/documentsService";
import { PDFDocument } from "pdf-lib";
import { jsPDF } from "jspdf";
import * as pdfjsLib from 'pdfjs-dist';

import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { getFieldvalueconfig } from "@/store/services/configuration/ActionService";
import {settings} from '@/settings';
// On aligne manuellement le worker
GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const processDocumentsOrder = async (payload: {
    gatheringProcess: any,
    requiredDocuments: any,
    supportingDocuments: any[],
    receivedFiles: any[],
    module:any,
    additionalInfoMap?: Map<string, any>
}) => {

    const {
        gatheringProcess,
        requiredDocuments,
        supportingDocuments,
        receivedFiles,
        module
    } = payload;

    const deleteManualDocs: any[] = [];
    let nbrTargetEntityNull = 0;


    const nbrDeleteManualDocs = deleteManualDocs.length ? deleteManualDocs.length : 0

    let listOfCheckpoints: any[] = []
    let nbrOfCheckPoint = 0;
    let nbrOfMandatoryDocuments = 0;
    let nbrOfMandatoryDocumentsValidated = 0;
    let nbrOfCheckPointValidated = 0;
    let nbrOfCheckPointNotValidated = 0;
    let nbrOfCheckPointMandatory = 0;
    let nbrOfCheckPointMandatoryValidated = 0;
    for (const requiredDocument of requiredDocuments){
        if(gatheringProcess.supportingDocuments.length===1){
            requiredDocument.supportingDocumentUid =gatheringProcess.supportingDocuments[0].resourceUid
        }else{
             const supportingDocument = gatheringProcess.supportingDocuments.find((s: any) =>
                requiredDocument.supportingType?.some((st: any) =>
                    st.supportingDocument?.resourceUid === s.documentFamily?.resourceUid
                )
            );
            if(!requiredDocument.supportingDocumentUid && supportingDocument){
             requiredDocument.supportingDocumentUid =supportingDocument.resourceUid
            }

        }

    }

    if (gatheringProcess && gatheringProcess.gatheringProcessItem && gatheringProcess.gatheringProcessItem[0] && gatheringProcess.gatheringProcessItem[0].items){
    for (const items of gatheringProcess.gatheringProcessItem[0].items) {
        const ListOfDocuments = []


        if (items.objectType.includes('fieldvalue') ) {
            nbrOfMandatoryDocuments++
            if (items.businessData) {
                items.status.resourceUid = 'COMPLETED'
                items.businessData = {}
                if(module==='taskModule') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                    nbrOfCheckPointMandatory++
                    nbrOfCheckPointMandatoryValidated++
                }
                nbrOfMandatoryDocumentsValidated++
            } else {
                items.status.resourceUid = 'PENDING'
                items.businessData = null
                if(module==='taskModule'){
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                    nbrOfCheckPointMandatory++
                }
            }
            if(items.fieldType&& items.fieldType.resourceUid && items.checkPointsConfig&&items.checkPointsConfig.resourceUid&&
                 items.fieldType.resourceUid=='LIST_VALUES' ){
                const checkPointsConfig =await getFieldvalueconfig(items.checkPointsConfig.resourceUid)
                if(checkPointsConfig.data){
                    items.checkPointsConfig.businessData=checkPointsConfig.data.businessData

                }
            }

            listOfCheckpoints.push(items)
        }

        if( items.objectType.includes('businessrulevalue')){
            nbrOfMandatoryDocuments++
            if (items.status.resourceUid === 'COMPLETED') {
                if(module==='taskModule') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                    nbrOfCheckPointMandatory++
                    nbrOfCheckPointMandatoryValidated++
                }
                nbrOfMandatoryDocumentsValidated++
            } else {
                if(module==='taskModule') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                    nbrOfCheckPointMandatory++
                }
            }

            listOfCheckpoints.push(items)
        }
        if (items.objectType.includes('documentvalue')) {
            const supDocumentsFiltered = supportingDocuments.filter((s: any) => s.resourceUid === items.supportingDocument.resourceUid)[0];
            if (supDocumentsFiltered) {
                for (const document of requiredDocuments) {
                    let documentUpload = {};
                    let creationDate = "";
                    let creationUser = "";
                    let status = "";
                    let comment = "";
                    let receivedFilesUid = "";
                    let receivedComment = "";
                    const doc = gatheringProcess.gatheringProcessItem[0].receivedFiles.filter(
                        (s: any) => s.content[0]?.documentType?.resourceUid === document.resourceUid
                    );
                    if ( doc.length > 0 ) {
                        documentUpload = {
                            format: "",
                            originalFileName: doc[doc.length - 1].content[0].label,
                            resourceUid: doc[doc.length - 1].fileReference?.resourceUid,
                            objectType: doc[doc.length - 1].fileReference?.objectType,
                            systemUid: doc[doc.length - 1].fileReference?.systemUid,
                            nbrOfPages: doc[doc.length - 1].content[0].nbrOfPages,
                        };
                        creationDate = doc[doc.length - 1].receptionDate;
                        status = doc[doc.length - 1].content[0].status?.resourceUid ?? "";
                        comment = doc[doc.length - 1].content[0].label;
                        receivedFilesUid = doc[doc.length - 1].resourceUid;
                        receivedComment = doc[doc.length - 1].receivedComment || '';
                        creationUser = doc[doc.length - 1].creationUser || '';

                    }

                    if(document.supportingDocumentUid===items.supportingDocument.resourceUid){
                        const supportingTypeMatched = document.supportingType?.find((st: any) =>
                            st.supportingDocument?.resourceUid === supDocumentsFiltered?.documentFamily?.resourceUid
                        );

                        ListOfDocuments.push({
                            documentUpload: documentUpload,
                            creationDate: creationDate,
                            status: status,
                            comment: comment,
                            typeJustify: supportingTypeMatched?.supportingDocument.resourceUid,
                            mandatory: supportingTypeMatched?.mandatory,
                            documentType: document.resourceUid,
                            toBeValidated: supportingTypeMatched?.toBeValidated,
                            toBeSigned: supportingTypeMatched?.toBeSigned ?? false,
                            rolesAllowed: supportingTypeMatched?.rolesAllowed,
                            documentStatus: supportingTypeMatched?.documentStatus,
                            processResourceUid: gatheringProcess.resourceUid,
                            receivedFilesUid: receivedFilesUid,
                            whoModified: creationUser,
                            receivedComment: receivedComment,
                            displayOrder: supportingTypeMatched?.displayOrder,
                            nbrOfPages: supportingTypeMatched?.nbrOfPages,
                            esignProcessId: doc.length > 0 ? doc[doc.length - 1].businessData?.esignProcessId : undefined,
                            // Origine du statut (ex. 'MANUAL' pour un forçage) : conditionne l'affichage de l'icône IA
                            statusOrigin: doc.length > 0 ? doc[doc.length - 1].businessData?.statusOrigin : undefined,
                            receivedFileBusinessData: doc.length > 0 ? doc[doc.length - 1].businessData : undefined,
                            businessData: supportingTypeMatched?.businessData,
                        })
                    }




                }
                // Tri interne des documents du checkpoint
                sortDocuments(ListOfDocuments)
                nbrTargetEntityNull = nbrTargetEntityNull + 1
                items.documents = ListOfDocuments
                listOfCheckpoints.push(items)

            }
            for(const doc of items.documents){
                if (doc.mandatory) {
                    nbrOfMandatoryDocuments++
                    nbrOfCheckPointMandatory++
                    if (doc.status === 'QUALIFIED' || doc.status === 'IN_PROGRESS'  || doc.status === 'OVERWRITE' || doc.status === 'VALID' || doc.status === 'SIGNED') {
                        nbrOfMandatoryDocumentsValidated++
                        nbrOfCheckPointMandatoryValidated++
                    }
                }
                if(doc.documentUpload && doc.documentUpload.originalFileName ){
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                }else{
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }
            }

        }
        if (items.objectType.includes('businessrulevalue') || items.objectType.includes('fieldvalue')) {
            if (module === 'orderModule' && payload.additionalInfoMap) {
                const info = payload.additionalInfoMap.get(items.resourceUid)
                if (info) {
                    const first_name = (info.first_name || '').trim()
                    const last_name = (info.last_name || '').trim()
                    items.whoModified = [first_name, last_name].filter(Boolean).join(' ').trim()
                    items.creationDate = info._when_created || items.creationDate
                }
            } else {
                const filter = { idCheck: items.resourceUid }
                const moreInfo = await getAdditionalInformation(filter)
                if (moreInfo.length > 0) {
                    items.whoModified = moreInfo[0].first_name + ' ' + moreInfo[0].last_name
                }
            }
        }

        }
    }

    const documentValueItems = listOfCheckpoints.filter(item => item.objectType.includes('documentvalue'));
    const otherItems = listOfCheckpoints.filter(item => !item.objectType.includes('documentvalue'));
    listOfCheckpoints = [...documentValueItems, ...otherItems];
    // --- APPLICATION DU TRI GLOBAL DES CHECKPOINTS ---
    listOfCheckpoints = sortDocumentsInTasksDetail(listOfCheckpoints);
    const gatheringProcessOrder={
        resourceUid: gatheringProcess.resourceUid,
        nbrReceivedItems: nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint,
        nbrValidatedItems: nbrOfCheckPointValidated + '/' + nbrOfCheckPoint,
        nbrOfMandatoryDocumentsValidated: nbrOfMandatoryDocumentsValidated,
        nbrOfMandatoryDocuments: nbrOfMandatoryDocuments,
        requiredDocuments: requiredDocuments.length - nbrTargetEntityNull - nbrDeleteManualDocs,
        status: nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory ? "COMPLETED" : "PROCESSING",
        assessmentContext: gatheringProcess.contextType.rawValue,
        checkpoints: listOfCheckpoints
    }
    if(module==='taskModule'){
        let listOfGatheringProcessOrder = store.state.taskModule.gatheringProcessOrder || [];
        if(listOfGatheringProcessOrder.length > 0){
            const exists = listOfGatheringProcessOrder.some((item:any) => item.resourceUid === gatheringProcessOrder.resourceUid);
            if (!exists) {
                listOfGatheringProcessOrder.push(gatheringProcessOrder);
            } else {
                listOfGatheringProcessOrder = listOfGatheringProcessOrder.map((obj:any) => obj.resourceUid === gatheringProcessOrder.resourceUid ? gatheringProcessOrder : obj)
            }
        } else {
            listOfGatheringProcessOrder.push(gatheringProcessOrder);
        }
        const totalValidated = listOfGatheringProcessOrder.reduce((sum:any, item:any) => sum + item.nbrOfMandatoryDocumentsValidated, 0);
        const totalMandatory = listOfGatheringProcessOrder.reduce((sum:any, item:any) => sum + item.nbrOfMandatoryDocuments, 0);
        if (totalValidated === totalMandatory) {
            store.dispatch('orderModule/setPreConditionValid', true);
        } else {
            store.dispatch('orderModule/setPreConditionValid', false);
        }
        await store.dispatch("taskModule/gatheringProcessOrder", {
            request: {
                gatheringProcess: listOfGatheringProcessOrder,
            },
        }).catch(e => console.error(e));
    }
    if(module==='orderModule'){
        // Use orderModule store slice for order detail hydration
        let listOfGatheringProcessOrder = store.state.orderModule.gatheringProcessOrder || [];
        if(listOfGatheringProcessOrder.length > 0){
            const existingIndex = listOfGatheringProcessOrder.findIndex((item:any) => item.resourceUid === gatheringProcessOrder.resourceUid);
            if (existingIndex === -1) {
                listOfGatheringProcessOrder.push(gatheringProcessOrder);
            } else {
                // Merge: update existing entry, preserving 'document' from processDocumentsOrderTab
                // and adding 'documents' array from processDocumentsOrder
                const existing = listOfGatheringProcessOrder[existingIndex];
                const mergedCheckpoints = existing.checkpoints.map((existingCp: any) => {
                    // Find matching checkpoint in new data by resourceUid
                    const newCp = gatheringProcessOrder.checkpoints.find((cp: any) => cp.resourceUid === existingCp.resourceUid);
                    if (newCp && newCp.documents) {
                        // Merge: keep existing data and add documents array
                        return { ...existingCp, documents: newCp.documents };
                    }
                    return existingCp;
                });
                // Update with merged data and new statistics
                listOfGatheringProcessOrder[existingIndex] = {
                    ...gatheringProcessOrder,
                    checkpoints: mergedCheckpoints
                };
            }
        } else {
            listOfGatheringProcessOrder.push(gatheringProcessOrder);
        }
        await store.dispatch("orderModule/gatheringProcessOrder", {
            request: {
                gatheringProcess: listOfGatheringProcessOrder,
            },
        }).catch(e => console.error(e));
    }
    if(module==='summaryPanelModule'){
        const listOfGatheringProcessOrderSummary= store.state.summaryPanelModule.gatheringProcessOrder || [];
        listOfGatheringProcessOrderSummary.push(gatheringProcessOrder)
        await store.dispatch("summaryPanelModule/gatheringProcessOrder", {
            request: {
                gatheringProcess: listOfGatheringProcessOrderSummary,
            },
        }).catch(e => console.error(e));
    }

    store.dispatch('orderModule/setPreConditionValid', false);
}

export const processDocumentsOffer =async (payload: {
    gatheringProcess: any
    requiredDocuments: any,
    module:any

}) => {

    const {
        gatheringProcess,
        requiredDocuments,
        module
    } = payload;

    const deleteManualDocs: any[] = [];
    let nbrTargetEntityNull = 0;
    const nbrDeleteManualDocs = deleteManualDocs.length ? deleteManualDocs.length : 0

    const listOfCheckpoints: any[] = []
    let nbrOfCheckPoint = 0;
    let nbrOfCheckPointValidated = 0;
    let nbrOfCheckPointNotValidated = 0;
    for (const requiredDocument of requiredDocuments){
        if(gatheringProcess.supportingDocuments.length===1){
            requiredDocument.supportingDocumentUid =gatheringProcess.supportingDocuments[0].resourceUid
        }else{
            const supportingDocument = gatheringProcess.supportingDocuments.filter((s: any) =>
            s.documentFamily.resourceUid === requiredDocument.supportingType[0].supportingDocument.resourceUid)[0];
            if(!requiredDocument.supportingDocumentUid && supportingDocument){
             requiredDocument.supportingDocumentUid =supportingDocument.resourceUid
            }

        }

    }

    if (gatheringProcess.gatheringProcessItem[0] && gatheringProcess.gatheringProcessItem[0].items) {

        for (const items of gatheringProcess.gatheringProcessItem[0].items) {

            const ListOfDocuments = []

            if (items.objectType.includes('documentvalue')) {
                const supDocumentsFiltered = gatheringProcess.supportingDocuments.filter((s: any) => s.resourceUid === items.supportingDocument.resourceUid)[0];
                if (supDocumentsFiltered) {
                    for (const document of requiredDocuments) {
                        let documentUpload = {};
                        let creationDate = "";
                        let status = "";
                        let comment = "";
                        const doc = gatheringProcess.gatheringProcessItem[0].receivedFiles.filter(
                            (s: any) => s.content[0]?.documentType?.resourceUid === document.resourceUid
                        );
                        if (doc.length > 0 && items.status && items.status.resourceUid === 'COMPLETED') {
                            documentUpload = {
                                format: "",
                                originalFileName: doc[doc.length - 1].content[0].label,
                                resourceUid: doc[doc.length - 1].fileReference.resourceUid,
                                objectType: doc[doc.length - 1].fileReference.objectType,
                                systemUid: doc[doc.length - 1].fileReference.systemUid,
                            };
                            creationDate = doc[doc.length - 1].receptionDate;
                            status = doc[doc.length - 1].content[0].status?.resourceUid ?? "";
                            comment = doc[doc.length - 1].content[0].label;


                        }

                        if(document.supportingDocumentUid===items.supportingDocument.resourceUid){
                            ListOfDocuments.push({
                                documentUpload: documentUpload,
                                creationDate: creationDate,
                                status: status,
                                comment: comment,
                                typeJustify: document.supportingType[0].supportingDocument.resourceUid,
                                documentType: document.resourceUid,
                                processResourceUid: gatheringProcess.resourceUid,
                                esignProcessId: doc.length > 0 ? doc[doc.length - 1].businessData?.esignProcessId : undefined,
                            })
                        }



                    }
                    nbrTargetEntityNull = nbrTargetEntityNull + 1
                    items.documents = ListOfDocuments
                    listOfCheckpoints.push(items)


                }


            }


            if (items.objectType.includes('fieldvalue')) {
                if (items.businessData) {
                    items.status.resourceUid = 'COMPLETED'
                    items.businessData = {}
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                } else {
                    items.status.resourceUid = 'PENDING'
                    items.businessData = null
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }
            listOfCheckpoints.push(items)
            }



            const filter = {
                idCheck: items.resourceUid
            }
           if ( items.objectType.includes('businessrulevalue') || items.objectType.includes('fieldvalue') ){
                const moreInfo = await getAdditionalInformation(filter)
                if (   moreInfo.length > 0 ) {
                    items.whoModified = moreInfo[0].first_name + ' ' + moreInfo[0].last_name
                }
            }
        }
    }

}
export async function UploadDocument(files: any, resourceUid: any, childId: any,index:any, from?:string, filePanelIndex?:any) {
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        if (process.resourceUid === resourceUid) {
            const documentItem = process.checkpoints[childId]


            const fileToVerify = Array.isArray(files)
                ? files[0]
                : files instanceof FileList
                    ? files[0]
                    : files;

            const aiLoadingIndex = `${resourceUid}_${childId}_${index}`;
            const iaVerification = await runAiVerification(
                fileToVerify,
                documentItem.documents[index].documentType,
                aiLoadingIndex
            );

            if (documentItem) {
                if(documentItem.documents[index].receivedFilesUid){
                    const body={file: from && from === "fromHandleFileToReplace" ? files : files[0],
                        doc:documentItem.documents[index],
                        filePanelIndex: filePanelIndex ?? undefined
                    }
                    await store.dispatch("taskModule/uploadDocumentModule/setUploadDocumentLoading",
                        {
                            "status": true,
                            "loadingIndex": aiLoadingIndex
                        }
                    )
                    const endUploadLoading = () => store.dispatch("taskModule/uploadDocumentModule/setUploadDocumentLoading",
                        {
                            "status": false,
                            "loadingIndex": null
                        }
                    )
                    let result
                    try {
                        result = (await concatFile(body)).data
                    } finally {
                        // Concaténation réussie : le tiroir reste « en transfert » jusqu'à son
                        // rafraîchissement, sans repasser par son ancien statut (EFLO-1048).
                        if (!result) {
                            await endUploadLoading()
                        }
                    }
                    if (result){

                        const documentType = documentItem.documents[index].documentType
                            // Attendu : la concaténation remplace le fichier reçu côté serveur,
                            // le dépôt suivant doit concaténer sur le nouveau receivedFilesUid.
                            await store.dispatch("taskModule/uploadDocumentModule/process", {
                                    processid: resourceUid,
                                    callback: async (response: any) =>
                                    {
                                        const receivedFiles = response.gatheringProcessItem
                                                              && response.gatheringProcessItem[0]
                                                              && response.gatheringProcessItem[0].receivedFiles
                                                              ? response.gatheringProcessItem[0].receivedFiles
                                                              : []
                                         const file = receivedFiles.filter(
                                                    (item: any) => item.content[0]?.documentType?.resourceUid === documentType && item.label !==''
                                          );

                                        if (file.length > 0){


                                            let modified = ''
                                            modified =file[file.length - 1].creationUser

                                            documentItem.documents[index].receivedFilesUid = file[file.length - 1].resourceUid
                                            documentItem.documents[index].creationDate= file[file.length - 1].receptionDate
                                            documentItem.documents[index].whoModified= modified ? modified : ''
                                            // Sans validation IA (désactivée par configuration), le document
                                            // reste au statut "qualifié" issu du dépôt.
                                            documentItem.documents[index].status = iaVerification?.status ?? 'QUALIFIED'
                                            documentItem.documents[index].comment = file[file.length - 1].content[0].label
                                            // Commentaire IA (issues / champs manquants) : on n'écrase pas un commentaire existant par du vide
                                            if (iaVerification?.comments) {
                                                documentItem.documents[index].receivedComment = iaVerification.comments
                                            }
                                                if (documentItem.documents[index] && documentItem.documents[index].documentUpload){
                                                    const  documentUpload = {
                                                        format: "",
                                                        originalFileName: file[file.length - 1].content[0].label,
                                                        resourceUid: file[file.length - 1].fileReference.resourceUid,
                                                        objectType: file[file.length - 1].fileReference.objectType,
                                                        systemUid: file[file.length - 1].fileReference.systemUid,
                                                        nbrOfPages: file[file.length - 1].content[0].nbrOfPages
                                                    };
                                                    documentItem.documents[index].documentUpload = documentUpload
                                                }
                                            // Keep Actions tab in sync: set the single document view used by preconditions table
                                            documentItem.document = deepClone(documentItem.documents[index]);
                                            //}

                                         }

                                    }
                            }).finally(endUploadLoading);
                    }
                }else{
                documentItem.documents[index].documentUpload = from && from === "fromHandleFileToReplace" ? files : files[0];
                if (documentItem.documents && documentItem.documents[index].documentUpload) {
                    await store.dispatch("taskModule/uploadDocumentModule/setUploadDocumentLoading",
                        {
                            "status": true,
                            "loadingIndex": `${resourceUid}_${childId}_${index}`
                        }
                    )
                    Notify.create({
                       message: i18n.global.t("order.messages.uploadBegin"),
                       color: "positive",
                    })
                    // Dépôt attendu jusqu'à son terme : sans IA, rien ne ralentissait l'appelant
                    // et un second fichier pour ce tiroir partait avant que receivedFilesUid ne
                    // soit connu, écrasant le premier au lieu de s'y concaténer (EFLO-1048).
                    await getBase64(documentItem.documents[index].documentUpload).then(async (base64) => {
                        const file = documentItem.documents[index].documentUpload;
                        let pageCount = 1; // valeur par défaut pour les images

                        if (file.type === 'application/pdf') {
                            const arrayBuffer = await file.arrayBuffer();
                            const pdfDoc = await PDFDocument.load(arrayBuffer, { ignoreEncryption: true });
                            pageCount = pdfDoc.getPageCount();
                        }
                        const fileContent: FileContent = {
                            originalFileName: documentItem.documents[index].documentUpload.name,
                            format: 'application/pdf',
                            content: base64,
                            nbrOfPages: pageCount,
                            relations: {
                                items: [
                                    {
                                        qualifier: {
                                            rawValue: documentItem.documents[index]?.documentType,
                                        },
                                        objectUON: {
                                            objectType: "odm.filemngt.filecontent",
                                            systemUid: UON.SystemUid.odmFileManagement,
                                        },
                                    },
                                ],
                            },
                        };


                        await store.dispatch("taskModule/uploadDocumentModule/uploadFile", {
                            request: fileContent,
                            documentType: documentItem.documents[index]?.documentType,
                            processid: process.resourceUid,
                            filePanelIndex: filePanelIndex ?? undefined,
                            iaVerification,
                            callback: (response: FileContent) =>
                                handleDocumentResponse(response, resourceUid, childId,index, iaVerification),
                        });
                    }).catch(async (error: any) => {
                        console.error("Erreur lors de la preparation du fichier :", error);
                        await store.dispatch("taskModule/uploadDocumentModule/setUploadDocumentLoading",
                            {
                                "status": false,
                                "loadingIndex": null
                            }
                        )
                    });
                } else {
                    Notify.create({
                        color: "negative",
                        message: "Erreur!",
                    });
                }
                }

            }

        }
    }
}
export async function UploadDocumentScanned(files: any, resourceUid: any, childId: any,index:any) {
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        if (process.resourceUid === resourceUid) {
            const documentItem = process.checkpoints[childId]
            if (documentItem) {
                if(documentItem.documents[index].receivedFilesUid){
                    const body={file:files[0].rawData,
                        doc:documentItem.documents[index]
                    }
                    concatFile(body)
                }else{
                    documentItem.documents[index].documentUpload = files[0].rawData;
                    if (documentItem.documents && documentItem.documents[index].documentUpload) {
                        // Validation IA du document scanné : set par-document (parallèle), pas le loader
                        // global. `undefined` si l'IA est désactivée par configuration (VUE_APP_IA=false).
                        const aiLoadingIndex = `${resourceUid}_${childId}_${index}`;
                        const iaVerification = await runAiVerification(
                            files[0].rawData,
                            documentItem.documents[index].documentType,
                            aiLoadingIndex
                        );

                        store.dispatch("taskModule/uploadDocumentModule/uploadFile", {
                            request: files[0].rawData,
                            documentType: documentItem.documents[index]?.documentType,
                            processid: process.resourceUid,
                            iaVerification,
                            callback: (response: FileContent) =>
                                handleDocumentResponse(response, resourceUid, childId,index, iaVerification),
                        });
                    } else {
                        Notify.create({
                            color: "negative",
                            message: "Erreur!",
                        });
                    }
                }

            }

        }
    }
}

export async function UploadDocumentOffer(files: any, resourceUid: any, childId: any,index:any) {
    for (const process of store.state.taskModule.gatheringProcess) {
        if (process.resourceUid === resourceUid) {
            const documentItem = process.gatheringProcessItem[0].items[childId]
            if (documentItem) {
                documentItem.documents[index].documentUpload = files[0];
                if (documentItem.documents && documentItem.documents[index].documentUpload) {
                    getBase64(documentItem.documents[index].documentUpload).then((base64) => {
                        const fileContent: FileContent = {
                            originalFileName: documentItem.documents[index].documentUpload.name,
                            format: documentItem.documents[index].documentUpload.type,
                            content: base64,
                            relations: {
                                items: [
                                    {
                                        qualifier: {
                                            rawValue: documentItem.documents[index]?.documentType,
                                        },
                                        objectUON: {
                                            objectType: "odm.filemngt.filecontent",
                                            systemUid: UON.SystemUid.odmFileManagement,
                                        },
                                    },
                                ],
                            },
                        };


                        store.dispatch("taskModule/uploadDocumentModule/uploadFile", {
                            request: fileContent,
                            documentType: documentItem.documents[index]?.documentType,
                            processid: process.resourceUid,
                            callback: (response: FileContent) =>
                                handleDocumentOfferResponse(response, resourceUid, childId,index),
                        });
                    });


                } else {
                    Notify.create({
                        color: "negative",
                        message: "Erreur!",
                    });
                }
            }

        }
    }
}
export async function handleDocumentResponse(response: FileContent, resourceUid: any, childId: number,index: number, iaVerification?: { status: string; comments: string }) {
    let nbrOfMandatoryDocuments = 0;
    let nbrOfMandatoryDocumentsValidated = 0;
    let nbrOfCheckPointMandatory = 0;
    let nbrOfCheckPointMandatoryValidated = 0;
    const module = store.state.orderModule?.order?.reference ? 'orderModule' : 'taskModule';
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
         nbrOfCheckPointMandatory = 0;
         nbrOfCheckPointMandatoryValidated = 0;
        if (process.resourceUid === resourceUid) {
            const authName= store.getters["authModule/getAuthName"];
            process.checkpoints[childId].documents[index].documentUpload = response && response.isForcedDocument ? {} : response || {};
            process.checkpoints[childId].documents[index].creationDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            // Statut piloté par la validation IA si disponible (sinon QUALIFIED par défaut).
            // Le forçage manuel (OVERWRITE) et le commentaire (COMMENTED) restent prioritaires.
            process.checkpoints[childId].documents[index].status = response && response.isForcedDocument ? 'OVERWRITE' : response && response.isCommentedDocument ? 'COMMENTED' : (iaVerification?.status ?? 'QUALIFIED');
            process.checkpoints[childId].documents[index].comment = response?.originalFileName;
            // Commentaire issu de l'IA (issues / champs manquants) affiché dans la colonne commentaire
            if (iaVerification?.comments) {
                process.checkpoints[childId].documents[index].receivedComment = iaVerification.comments;
            }
            process.checkpoints[childId].status.resourceUid = 'COMPLETED'
            process.checkpoints[childId].documents[index].receivedFilesUid = response?.receivedFilesUid
            process.checkpoints[childId].documents[index].whoModified = authName
            // Keep Actions tab in sync: set the single document view used by preconditions table
            if (process.checkpoints[childId].objectType?.includes('documentvalue')) {
                process.checkpoints[childId].document = deepClone(process.checkpoints[childId].documents[index]);
            // Also set receivedFilesUid directly on checkpoint for easier access
            process.checkpoints[childId].receivedFilesUid = response?.receivedFilesUid
            }
            const documentValue = deepClone(process.checkpoints[childId])
            delete documentValue.documents
            delete documentValue.whoModified
            delete documentValue.receivedFilesUid
            const IsValid=process.checkpoints[childId].documents.filter((s: any) =>
            !['QUALIFIED','OVERWRITE'].includes(s.status));
            if(IsValid.length===0){
                documentValue.status = {
                    resourceUid: documentValue.status.resourceUid,
                    objectType: documentValue.status.objectType,
                    systemUid: documentValue.status.systemUid
                };
                documentValue.checkPointsConfig = {
                    resourceUid: documentValue.checkPointsConfig.resourceUid,
                    objectType: documentValue.checkPointsConfig.objectType,
                    systemUid: documentValue.checkPointsConfig.systemUid
                };
                documentValue.supportingDocument = {
                    resourceUid: documentValue.supportingDocument.resourceUid,
                    objectType: documentValue.supportingDocument.objectType,
                    systemUid: documentValue.supportingDocument.systemUid
                };
                store.dispatch("taskModule/updateDocumentValue", {
                    request: documentValue,
                });
            }

        }
        for (const items of process.checkpoints) {
            if( items.objectType.includes('documentvalue')){
                for(const doc of items.documents){
                    if (doc.mandatory) {
                        nbrOfMandatoryDocuments++
                        nbrOfCheckPointMandatory++
                        if (doc.status === 'QUALIFIED' || doc.status === 'IN_PROGRESS' || doc.status === 'OVERWRITE' || doc.status === 'VALID' || doc.status === 'SIGNED') {
                            nbrOfMandatoryDocumentsValidated++
                            nbrOfCheckPointMandatoryValidated++
                        }
                    }
                    if(doc.documentUpload && doc.documentUpload.originalFileName ){
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                    }else{
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                    }
                }

            }else{
                nbrOfMandatoryDocuments++
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    if(module==='taskModule') {
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                        nbrOfCheckPointMandatory++
                        nbrOfCheckPointMandatoryValidated++
                    }
                    nbrOfMandatoryDocumentsValidated++
                } else {
                    if(module==='taskModule') {
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                        nbrOfCheckPointMandatory++
                    }
                }

            }

        }
        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint
        if (nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory) {
            process.status = "COMPLETED"
        }
        else {
            process.status = "PROCESSING"
        }


    }
    if (nbrOfMandatoryDocumentsValidated === nbrOfMandatoryDocuments) {
        store.dispatch('orderModule/setPreConditionValid', true)
    } else {
        store.dispatch('orderModule/setPreConditionValid', false);
    }
    // Mirror updated taskModule list into orderModule so order/detail tabs update without refetch
    await store.dispatch("orderModule/gatheringProcessOrder", {
        request: { gatheringProcess: store.state.taskModule.gatheringProcessOrder },
    }).catch(e => console.error(e));
    const orderId662 = store.state.orderModule?.order?.resourceUid || store.state.taskModule?.order?.resourceUid;
    if (resourceUid) {
        await getRequiredDocumentValidatedByBR(resourceUid, orderId662, module).catch(e => console.error(e));
    }
}

export async function handleDocumentOfferResponse(response: FileContent, resourceUid: any, childId: number,index: number) {
    for (const process of store.state.taskModule.gatheringProcess) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
        if (process.resourceUid === resourceUid) {
            const authName= store.getters["authModule/getAuthName"];
            process.gatheringProcessItem[0].items[childId].documents[index].documentUpload = response || {};
            process.gatheringProcessItem[0].items[childId].documents[index].creationDate = moment(new Date()).format("DD/MM/YYYY  HH:mm:ss");
            process.gatheringProcessItem[0].items[childId].documents[index].status = 'QUALIFIED';
            process.gatheringProcessItem[0].items[childId].documents[index].comment = response.originalFileName;
            process.gatheringProcessItem[0].items[childId].whoModified = authName
            process.gatheringProcessItem[0].items[childId].status.resourceUid = 'COMPLETED'
            const documentValue = deepClone(process.gatheringProcessItem[0].items[childId])
            delete documentValue.documents
            delete documentValue.whoModified
            const IsValid=process.gatheringProcessItem[0].items[childId].documents.filter((s: any) =>
            s.status !== 'QUALIFIED');
            if(IsValid.length===0){
                store.dispatch("taskModule/updateDocumentValue", {
                    request: documentValue,
                });
            }

        }
        for (const items of process.gatheringProcessItem[0].items) {
            if( items.objectType.includes('documentvalue')){
                for(const doc of items.documents){
                    if(doc.documentUpload && doc.documentUpload.originalFileName ){
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                    }else{
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                    }
                }

            }else{
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }

            }

        }
        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint

        if (nbrOfCheckPointValidated === nbrOfCheckPoint) {
            store.dispatch('orderModule/setPreConditionValid', true)
        }


    }
}

export function getBase64New(file: any) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const resp = reader.result as string;
            resolve(resp.split("base64,")[1]);
        };
        reader.onerror = (error) => reject(error instanceof Error ? error : new Error('FileReader error'));
    });
}
export function getBase64(file: any) {
    return new Promise((resolve, reject) => {
        (async () => {
            try {
                if(file.type && (file.type === "image/png" || file.type === "image/jpeg")){
                    const base64Image = await getBase64New(file);
                    const pdf = new jsPDF();
                    const img = new Image();
                    img.src = `data:${file.type};base64,${base64Image}`; // Assurez-vous que le type d'image est correct
                    img.onload = () => {
                        pdf.addImage(img, file.type === 'image/png' ? 'PNG' : 'JPEG', 10, 10, 190, 0); // Ajustez les dimensions selon vos besoins
                        const pdfBase64 = pdf.output('datauristring');
                        resolve(pdfBase64.split("base64,")[1]); // Retourne uniquement la partie base64
                    };

                    img.onerror = (error) => {
                        reject(new Error('Erreur lors du chargement de l\'image : ' + error));
                    };
                } else {
                    //  Contrôle de taille en octets : 10 Mo = 10 * 1024 * 1024 = 10485760
                    const fileSizeInBytes = file.size;
                    let finalFile = file;

                    if (fileSizeInBytes > 10 * 1024 * 1024) {
                        finalFile = await compressPDF(file);
                    }

                    const base64 = await getBase64New(finalFile);
                    resolve(base64);
                }

            } catch (error) {
                reject(error instanceof Error ? error : new Error(String(error)));
            }
        })();
    });
}

export function removeItem(resourceUid: any, i: number,index: number) {
    store.dispatch('orderModule/setPreConditionValid', false)
    let nbrOfMandatoryDocuments = 0;
    let nbrOfMandatoryDocumentsValidated = 0;
    let nbrOfCheckPointMandatory = 0;
    let nbrOfCheckPointMandatoryValidated = 0;
    const module = store.state.orderModule?.order?.reference ? 'orderModule' : 'taskModule';
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
         nbrOfCheckPointMandatory = 0;
         nbrOfCheckPointMandatoryValidated = 0;
        if (process.resourceUid === resourceUid) {
            process.checkpoints[i].documents[index].documentUpload = {}
            process.checkpoints[i].documents[index].status = "PENDING";
            process.checkpoints[i].documents[index].receivedFilesUid= "";
            process.checkpoints[i].documents[index].creationDate= "";
            process.checkpoints[i].documents[index].comment= "";
            process.checkpoints[i].documents[index].whoModified = "";
            process.checkpoints[i].documents[index].receivedComment = "";
            if (process.checkpoints[i].objectType?.includes('documentvalue')) {
                process.checkpoints[i].document = deepClone(process.checkpoints[i].documents[index]);
            }

            if (process.checkpoints[i].status) {
                const authName= store.getters["authModule/getAuthName"];
                process.checkpoints[i].status.resourceUid = 'PENDING'
                process.checkpoints[i].whoModified = authName
                const documentValue = deepClone(process.checkpoints[i])
                delete documentValue.documents
                delete documentValue.whoModified
                delete documentValue.creationDate
                documentValue.status = {
                    resourceUid: documentValue.status.resourceUid,
                    objectType: documentValue.status.objectType,
                    systemUid: documentValue.status.systemUid
                };
                documentValue.checkPointsConfig = {
                    resourceUid: documentValue.checkPointsConfig.resourceUid,
                    objectType: documentValue.checkPointsConfig.objectType,
                    systemUid: documentValue.checkPointsConfig.systemUid
                };
                documentValue.supportingDocument = {
                    resourceUid: documentValue.supportingDocument.resourceUid,
                    objectType: documentValue.supportingDocument.objectType,
                    systemUid: documentValue.supportingDocument.systemUid
                };
                store.dispatch("taskModule/updateDocumentValue", {
                    request: documentValue,
                });
            }
        }
        for (const items of process.checkpoints) {
            if( items.objectType.includes('documentvalue')){
                for(const doc of items.documents){
                    if (doc.mandatory) {
                        nbrOfMandatoryDocuments++
                        nbrOfCheckPointMandatory++
                        if (doc.status === 'QUALIFIED' || doc.status === 'IN_PROGRESS'  || doc.status === 'OVERWRITE' || doc.status === 'VALID' || doc.status === 'SIGNED') {
                            nbrOfMandatoryDocumentsValidated++
                            nbrOfCheckPointMandatoryValidated++
                        }
                    }
                    if(doc.documentUpload && doc.documentUpload.originalFileName ){
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                    }else{
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                    }
                }

            }else{
                nbrOfMandatoryDocuments++
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    if(module==='taskModule') {
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                        nbrOfCheckPointMandatory++
                        nbrOfCheckPointMandatoryValidated++
                    }
                    nbrOfMandatoryDocumentsValidated++
                } else {
                    if(module==='taskModule') {
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                        nbrOfCheckPointMandatory++
                    }
                }

            }

        }

        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint

        if (nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory) {
            process.status = "COMPLETED"
        }
        else {
            process.status = "PROCESSING"
        }
    }

    if (nbrOfMandatoryDocumentsValidated === nbrOfMandatoryDocuments) {
        store.dispatch('orderModule/setPreConditionValid', true)
    }
    store.dispatch("orderModule/gatheringProcessOrder", {
        request: { gatheringProcess: store.state.taskModule.gatheringProcessOrder },
    }).catch(e => console.error(e));
}

export function removeOfferItem(resourceUid: any, i: number,index: number) {
    for (const process of store.state.taskModule.gatheringProcess) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
        if (process.resourceUid === resourceUid) {
            process.gatheringProcessItem[0].items[i].documents[index].documentUpload = {}
            process.gatheringProcessItem[0].items[i].documents[index].status = "";
            const authName= store.getters["authModule/getAuthName"];
            if (process.gatheringProcessItem[0].items[i].status) {
                process.gatheringProcessItem[0].items[i].status.resourceUid = 'PENDING'
                process.gatheringProcessItem[0].items[i].whoModified = authName
                const documentValue = deepClone(process.gatheringProcessItem[0].items[i])
                delete documentValue.documents
                delete documentValue.whoModified

                store.dispatch("taskModule/updateDocumentValue", {
                    request: documentValue,
                });
            }
        }
        for (const items of process.gatheringProcessItem[0].items) {
            if( items.objectType.includes('documentvalue')){
                for(const doc of items.documents){
                    if(doc.documentUpload && doc.documentUpload.originalFileName ){
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                    }else{
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                    }
                }

            }else{
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }

            }

        }
        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint


    }
}

/**
 * Valide une precondition de type saisie, ou la rouvre.
 *
 * `businessData` porte deux roles a la fois sur un `fieldvalue` : il marque la
 * ligne comme non saisissable, et il est le SEUL support de persistance de l'etat
 * valide - l'hydratation force `PENDING` sur tout champ qui en est depourvu
 * (voir le traitement des `fieldvalue` en tete de ce fichier). Un objet vide vaut
 * donc « valide », `null` vaut « a saisir ». D'ou le couplage strict ci-dessous
 * entre le statut demande et ce marqueur : les dissocier ferait perdre la
 * validation au rechargement, ou figerait la ligne en lecture seule.
 *
 * @param resourceUid jalon portant le checkpoint
 * @param index       position du checkpoint dans le jalon
 * @param status      `COMPLETED` pour valider, `PENDING` pour rouvrir la saisie
 */
export async function validateField(resourceUid: any, index: number, status: 'COMPLETED' | 'PENDING' = 'COMPLETED') {
    let nbrOfMandatoryDocuments = 0;
    let nbrOfMandatoryDocumentsValidated = 0;
    let nbrOfCheckPointMandatory = 0;
    let nbrOfCheckPointMandatoryValidated = 0;
   const authName= store.getters["authModule/getAuthName"];
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
        nbrOfCheckPointMandatory = 0;
        nbrOfCheckPointMandatoryValidated = 0;
        if (process.resourceUid === resourceUid) {
            if( status === 'COMPLETED' &&
                process.checkpoints[index].fieldValue !== undefined &&
                process.checkpoints[index].fieldValue  !== "" &&
                process.checkpoints[index].fieldType.resourceUid === "DATE" &&
                !isValidDate(process.checkpoints[index].fieldValue)){
                Notify.create({
                    message: i18n.global.t("main.date.invalidDate"),
                    color: "negative",
                });
                process.checkpoints[index].fieldValue ='';
                break;
            }
            if (process.checkpoints[index].status) {
                process.checkpoints[index].status.resourceUid = status
                process.checkpoints[index].completionDate = moment().format("DD/MM/YYYY HH:mm:ss");
                process.checkpoints[index].businessData = status === 'COMPLETED' ? {} : null
                const fieldValue = deepClone(process.checkpoints[index])
                delete fieldValue.whoModified
                fieldValue.completionDate = moment().format("YYYY-MM-DD HH:mm:ss");

                if(fieldValue.objectType.includes('fieldvalue') &&fieldValue.checkPointsConfig&&fieldValue.checkPointsConfig.resourceUid ){
                    const data = await getEntity("odm-supportingdocument","fieldvalueconfig",fieldValue.checkPointsConfig.resourceUid);
                    if(data&&data.fieldObjectType){
                       if(data.fieldObjectType.endsWith('ordercar')
                        &&store.state.taskModule.order
                        &&store.state.taskModule.order.orderItems &&store.state.taskModule.order.orderItems.length>0
                        &&store.state.taskModule.order.orderItems[0].orderAssets &&store.state.taskModule.order.orderItems[0].orderAssets.length>0
                        &&store.state.taskModule.order.orderItems[0].orderAssets[0].resourceUid){
                        fieldValue.targetEntityUid = store.state.taskModule.order.orderItems[0].orderAssets[0].resourceUid;
                       }
                       if(data.fieldObjectType.endsWith('orderitem')
                        &&store.state.taskModule.order
                        &&store.state.taskModule.order.orderItems &&store.state.taskModule.order.orderItems.length>0
                        &&store.state.taskModule.order.orderItems[0].resourceUid ){
                        fieldValue.targetEntityUid=store.state.taskModule.order.orderItems[0].resourceUid
                       }
                       if(data.fieldObjectType.endsWith('orderdeliverydetails')
                        &&store.state.taskModule.order
                        &&store.state.taskModule.order.orderItems &&store.state.taskModule.order.orderItems.length>0
                        &&store.state.taskModule.order.orderItems[0].orderAssets &&store.state.taskModule.order.orderItems[0].orderAssets.length>0
                        &&store.state.taskModule.order.orderItems[0].orderAssets[0].assetDelivery
                        &&store.state.taskModule.order.orderItems[0].orderAssets[0].assetDelivery.resourceUid ){
                        fieldValue.targetEntityUid=store.state.taskModule.order.orderItems[0].orderAssets[0].assetDelivery.resourceUid
                       }

                    }
                }
                fieldValue.status = {
                    resourceUid: fieldValue.status.resourceUid,
                    objectType: fieldValue.status.objectType,
                    systemUid: fieldValue.status.systemUid
                };
                fieldValue.checkPointsConfig = {
                    resourceUid: fieldValue.checkPointsConfig.resourceUid,
                    objectType: fieldValue.checkPointsConfig.objectType,
                    systemUid: fieldValue.checkPointsConfig.systemUid
                };
                fieldValue.fieldType = {
                    resourceUid: fieldValue.fieldType.resourceUid,
                    objectType: fieldValue.fieldType.objectType,
                    systemUid: fieldValue.fieldType.systemUid
                };
                await store.dispatch("taskModule/updateFieldValue", {
                    request: fieldValue,
                });

                if(fieldValue.fieldType&&fieldValue.fieldType.resourceUid && fieldValue.fieldType.resourceUid === "DATE" ){
                    fieldValue.fieldValue=formatDateLocale(fieldValue.fieldValue, 'DD/MM/YYYY', 'fr')
                    if(fieldValue.checkPointsConfig&&fieldValue.checkPointsConfig.resourceUid&&
                        fieldValue.checkPointsConfig.resourceUid==='CHKPT_Date_Liv_Phys'){
                            fieldValue.fieldValue=fieldValue.fieldValue+' 00:00'
                        }
                }
                const checkpointPayload = deepClone(fieldValue);
                delete checkpointPayload.targetEntityUid;
                await store.dispatch("taskModule/saveCheckPointsValue", {
                    request: checkpointPayload,
                });
            }
            process.checkpoints[index].whoModified = authName
        }
        for (const items of process.checkpoints) {
            if( items.objectType.includes('documentvalue')){
                for(const doc of items.documents){
                    if (doc.mandatory) {
                        nbrOfMandatoryDocuments++
                        nbrOfCheckPointMandatory++
                        if (doc.status === 'QUALIFIED' || doc.status === 'IN_PROGRESS'  || doc.status === 'OVERWRITE' || doc.status === 'VALID' || doc.status === 'SIGNED') {
                            nbrOfMandatoryDocumentsValidated++
                            nbrOfCheckPointMandatoryValidated++
                        }
                    }
                    if(doc.documentUpload && doc.documentUpload.originalFileName ){
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                    }else{
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                    }
                }

            }else{
                nbrOfMandatoryDocuments++
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                    nbrOfMandatoryDocumentsValidated++
                    nbrOfCheckPointMandatory++
                    nbrOfCheckPointMandatoryValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                    nbrOfCheckPointMandatory++
                }

            }

        }

        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint
        if (nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory) {
            process.status = "COMPLETED"
        }
        else {
            process.status = "PROCESSING"
        }
    }
    if (nbrOfMandatoryDocumentsValidated === nbrOfMandatoryDocuments) {
        store.dispatch('orderModule/setPreConditionValid', true)
    } else {
        store.dispatch('orderModule/setPreConditionValid', false);
    }
}

 function isValidDate(fieldValue: any): boolean {
    if (!checkFormatDate(fieldValue)) {
      return false;
    }
    const parts = fieldValue.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    const currentYear =  new Date().getFullYear();
    if (month < 0 || month > 11 || year < currentYear - 10 || year > currentYear + 10) {
      return false;
    }
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
  }

export function removeFieldValue(resourceUid: any, index: number) {
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
        let nbrOfMandatoryDocuments = 0;
        let nbrOfMandatoryDocumentsValidated = 0;
        let nbrOfCheckPointMandatory = 0;
        let nbrOfCheckPointMandatoryValidated = 0;
        if (process.resourceUid === resourceUid) {
            if (process.checkpoints[index].status) {
                process.checkpoints[index].status.resourceUid = 'PENDING'
                process.checkpoints[index].completionDate = null;
                process.checkpoints[index].businessData = null
                const fieldValue = deepClone(process.checkpoints[index])
                delete fieldValue.whoModified
                fieldValue.status = {
                    resourceUid: fieldValue.status.resourceUid,
                    objectType: fieldValue.status.objectType,
                    systemUid: fieldValue.status.systemUid
                };
                fieldValue.checkPointsConfig = {
                    resourceUid: fieldValue.checkPointsConfig.resourceUid,
                    objectType: fieldValue.checkPointsConfig.objectType,
                    systemUid: fieldValue.checkPointsConfig.systemUid
                };
                fieldValue.fieldType = {
                    resourceUid: fieldValue.fieldType.resourceUid,
                    objectType: fieldValue.fieldType.objectType,
                    systemUid: fieldValue.fieldType.systemUid
                };
                store.dispatch("taskModule/updateFieldValue", {
                    request: fieldValue,
                });
            }
            const authName= store.getters["authModule/getAuthName"];
            process.checkpoints[index].whoModified = authName
        }
        for (const items of process.checkpoints) {
            if( items.objectType.includes('documentvalue')){
                for(const doc of items.documents){
                    if (doc.mandatory) {
                        nbrOfMandatoryDocuments++
                        nbrOfCheckPointMandatory++
                        if (doc.status === 'QUALIFIED' || doc.status === 'IN_PROGRESS'  || doc.status === 'OVERWRITE' || doc.status === 'VALID' || doc.status === 'SIGNED') {
                            nbrOfMandatoryDocumentsValidated++
                            nbrOfCheckPointMandatoryValidated++
                        }
                    }
                    if(doc.documentUpload && doc.documentUpload.originalFileName ){
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                    }else{
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                    }
                }

            }else{
                nbrOfMandatoryDocuments++
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                    nbrOfMandatoryDocumentsValidated++
                    nbrOfCheckPointMandatory++
                    nbrOfCheckPointMandatoryValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                    nbrOfCheckPointMandatory++
                }

            }

        }
        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint

         if (nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory) {
            process.status = "COMPLETED"
        }
        else {
            process.status = "PROCESSING"
        }
    }

    store.dispatch('orderModule/setPreConditionValid', false)
}

function formatDate(date: any) {
    const [day, month, year] = date.split('/').map(Number);
    return new Date(year, month - 1, day).toISOString().split('T')[0];
}

export const processDocumentsOrderTab = async (payload: {
    gatheringProcess: any,
    requiredDocuments: any,
    supportingDocuments: any[],
    receivedFiles: any[],
    module:any,
    additionalInfoMap?: Map<string, any>
}) => {

    const {
        gatheringProcess,
        requiredDocuments,
        supportingDocuments,
        receivedFiles,
        module
    } = payload;

    const deleteManualDocs: any[] = [];
    const nbrDeleteManualDocs = deleteManualDocs.length ? deleteManualDocs.length : 0
    const listOfCheckpoints: any[] = []
    let nbrTargetEntityNull = 0;
    let nbrOfCheckPoint = 0;
    let nbrOfMandatoryDocuments = 0;
    let nbrOfMandatoryDocumentsValidated = 0;
    let nbrOfCheckPointValidated = 0;
    let nbrOfCheckPointNotValidated = 0;
    let nbrOfCheckPointMandatory = 0;
    let nbrOfCheckPointMandatoryValidated = 0;

    for (const requiredDocument of requiredDocuments){
        if(gatheringProcess.supportingDocuments.length===1){
            requiredDocument.supportingDocumentUid =gatheringProcess.supportingDocuments[0].resourceUid
        }else{

            const supportingDocument = gatheringProcess.supportingDocuments.find((s: any) =>
                requiredDocument.supportingType?.some((st: any) =>
                    st.supportingDocument?.resourceUid === s.documentFamily?.resourceUid
                )
            );
            if(!requiredDocument.supportingDocumentUid && supportingDocument){
             requiredDocument.supportingDocumentUid =supportingDocument.resourceUid
            }
        }
        let documentUpload: any = null;
        let creationDate = "";
        let creationUser = "";
        let status = "";
        let comment = "";
        let receivedFilesUid = "";
        let receivedComment = "";
        const doc = gatheringProcess.gatheringProcessItem[0].receivedFiles.filter(
            (s: any) => s.content[0]?.documentType?.resourceUid === requiredDocument.resourceUid
        );
        if (doc.length > 0 ) {
            documentUpload = {
                format: "",
                originalFileName: doc[doc.length - 1].content[0].label,
                resourceUid: doc[doc.length - 1].fileReference?.resourceUid,
                objectType: doc[doc.length - 1].fileReference?.objectType,
                systemUid: doc[doc.length - 1].fileReference?.systemUid,
                nbrOfPages:  doc[doc.length - 1].content[0]?.nbrOfPages
            };
            creationDate = doc[doc.length - 1].receptionDate;
            creationUser = doc[doc.length - 1].creationUser;
            status = doc[doc.length - 1].content[0].status?.resourceUid ?? "";
            comment = doc[doc.length - 1].content[0].label;
            receivedFilesUid=doc[doc.length - 1].resourceUid
            receivedComment = doc[doc.length - 1].receivedComment || '';



        }
        if (gatheringProcess && gatheringProcess.gatheringProcessItem && gatheringProcess.gatheringProcessItem[0] && gatheringProcess.gatheringProcessItem[0].items){
        for (const items of gatheringProcess.gatheringProcessItem[0].items) {
            if(items.objectType && items.objectType.includes('documentvalue')){

            const supDocumentsFiltered = supportingDocuments.filter((s: any) => s.resourceUid === items.supportingDocument.resourceUid)[0];
                if (supDocumentsFiltered) {
                    if(requiredDocument.supportingDocumentUid===items.supportingDocument.resourceUid){
                        const supportingTypeMatched = requiredDocument.supportingType?.find((st: any) =>
                            st.supportingDocument?.resourceUid === supDocumentsFiltered?.documentFamily?.resourceUid
                        );

                        const documentObject ={
                            documentUpload: documentUpload,
                            creationDate: creationDate,
                            status: status ? status : 'PENDING',
                            comment: comment,
                            typeJustify: supportingTypeMatched?.supportingDocument.resourceUid,
                            mandatory: supportingTypeMatched?.mandatory,
                            documentType: requiredDocument.resourceUid,
                            toBeSigned: supportingTypeMatched?.toBeSigned ?? false,
                            processResourceUid: gatheringProcess.resourceUid,
                            rolesAllowed: supportingTypeMatched?.rolesAllowed,
                            documentStatus: supportingTypeMatched?.documentStatus,
                            receivedFilesUid: receivedFilesUid,
                            whoModified: creationUser ? creationUser : '',
                            whenModified: creationDate ? creationDate : '',
                            receivedComment: receivedComment,
                            displayOrder: supportingTypeMatched?.displayOrder,
                            nbrOfPages: supportingTypeMatched?.nbrOfPages,
                            businessData: supportingTypeMatched?.businessData,
                        }
                        items.document=documentObject
                        // Also create documents array with single document for Documents tab compatibility
                        items.documents = [documentObject]

                        items.whoModified = creationUser ? creationUser : ''
                        items.creationDate =creationDate ? creationDate : ''

                        items.processId=gatheringProcess.resourceUid
                        items.processItemsId=gatheringProcess.gatheringProcessItem[0].resourceUid
                        items.receivedFilesUid=receivedFilesUid

                        // Count statistics
                        nbrTargetEntityNull++;
                        if (supportingTypeMatched?.mandatory) {
                            nbrOfMandatoryDocuments++;
                            nbrOfCheckPointMandatory++;
                        }
                        nbrOfCheckPoint++;
                        if ((documentUpload && documentUpload.originalFileName) || status === 'OVERWRITE') {
                            nbrOfCheckPointValidated++;
                            if (supportingTypeMatched?.mandatory) {
                                nbrOfMandatoryDocumentsValidated++;
                                nbrOfCheckPointMandatoryValidated++;
                            }
                        } else {
                            nbrOfCheckPointNotValidated++;
                        }

                        const checkPoint = deepClone(items)
                        listOfCheckpoints.push(checkPoint)
                    }
                }
            }
        }
    }
    }
    if (gatheringProcess && gatheringProcess.gatheringProcessItem && gatheringProcess.gatheringProcessItem[0] && gatheringProcess.gatheringProcessItem[0].items){
    for (const items of gatheringProcess.gatheringProcessItem[0].items) {
        if((items.objectType && items.objectType.includes('fieldvalue') )|| (items.objectType && items.objectType.includes('businessrulevalue'))){
            if (module === 'orderModule' && payload.additionalInfoMap) {
                const info = payload.additionalInfoMap.get(items.resourceUid)
                if (info) {
                    const first_name = (info.first_name || '').trim()
                    const last_name = (info.last_name || '').trim()
                    items.whoModified = [first_name, last_name].filter(Boolean).join(' ').trim()
                    items.creationDate = info._when_created
                }
            } else {
                const filter = { idCheck: items.resourceUid }
                const moreInfo = await getAdditionalInformation(filter)
                if (moreInfo.length > 0) {
                    items.whoModified = moreInfo[0].first_name + ' ' + moreInfo[0].last_name
                    items.creationDate =moreInfo[0]._when_created
                }
            }

            // Count statistics for actions/controls
            nbrOfCheckPoint++;
            nbrOfMandatoryDocuments++;
            nbrOfCheckPointMandatory++;
            if (items.status && items.status.resourceUid === 'COMPLETED') {
                nbrOfCheckPointValidated++;
                nbrOfMandatoryDocumentsValidated++;
                nbrOfCheckPointMandatoryValidated++;
            } else {
                nbrOfCheckPointNotValidated++;
            }

            listOfCheckpoints.push(items)
        }

    }
}
    // Appel de la méthode de tri
    sortDocuments(listOfCheckpoints);

    const gatheringProcessOrder={
        resourceUid: gatheringProcess.resourceUid,
        nbrReceivedItems: nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint,
        nbrValidatedItems: nbrOfCheckPointValidated + '/' + nbrOfCheckPoint,
        nbrOfMandatoryDocumentsValidated: nbrOfMandatoryDocumentsValidated,
        nbrOfMandatoryDocuments: nbrOfMandatoryDocuments,
        requiredDocuments: requiredDocuments.length - nbrTargetEntityNull,
        status: nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory ? "COMPLETED" : "PROCESSING",
        assessmentContext: gatheringProcess.contextType.rawValue,
        checkpoints: listOfCheckpoints,

    }
        let listOfGatheringProcessOrder= store.state.orderModule.gatheringProcessOrder || [];
         if(listOfGatheringProcessOrder.length > 0){
            const exists = listOfGatheringProcessOrder.some((item:any) => item.resourceUid === gatheringProcessOrder.resourceUid);
            if (!exists) {
                listOfGatheringProcessOrder.push(gatheringProcessOrder);
            } else {
              listOfGatheringProcessOrder= listOfGatheringProcessOrder.map((obj:any) => obj.resourceUid === gatheringProcessOrder.resourceUid ? gatheringProcessOrder : obj)
            }
        } else {
            listOfGatheringProcessOrder.push(gatheringProcessOrder);
        }
        await store.dispatch("orderModule/gatheringProcessOrder", {
            request: {
                gatheringProcess: listOfGatheringProcessOrder,
            },
        }).catch(e => console.error(e));



}



export function validateBusinessField(resourceUid: any, index: number) {
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
        if (process.resourceUid === resourceUid) {
            if (process.checkpoints[index].status) {
                process.checkpoints[index].status.resourceUid = 'COMPLETED'
                process.checkpoints[index].completionDate = formatDate(moment(new Date()).format("DD/MM/YYYY HH:mm:ss"));
                const fieldValue = deepClone(process.checkpoints[index])
                delete fieldValue.whoModified
                fieldValue.status = {
                    resourceUid: fieldValue.status.resourceUid,
                    objectType: fieldValue.status.objectType,
                    systemUid: fieldValue.status.systemUid
                };
                fieldValue.checkPointsConfig = {
                    resourceUid: fieldValue.checkPointsConfig.resourceUid,
                    objectType: fieldValue.checkPointsConfig.objectType,
                    systemUid: fieldValue.checkPointsConfig.systemUid
                };
                store.dispatch("taskModule/updateCheckPointsStatus", {
                    request: fieldValue,
                });
            }
            const authName= store.getters["authModule/getAuthName"];
            process.checkpoints[index].whoModified = authName
        }

        for (const items of process.checkpoints) {
            if( items.objectType.includes('businessrulevalue')){
                if (items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }
            }else{
                if (items.status && items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }

            }

        }
        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint
        if (nbrOfCheckPointValidated === nbrOfCheckPoint) {
            store.dispatch('orderModule/setPreConditionValid', true)
        }
    }
    // Mirror updated list to orderModule
    store.dispatch("orderModule/gatheringProcessOrder", {
        request: { gatheringProcess: store.state.taskModule.gatheringProcessOrder },
    }).catch(e => console.error(e));
}

export function updateBusinessField(resourceUid: any, index: number, status: string) {
    let nbrOfMandatoryDocuments = 0;
    let nbrOfMandatoryDocumentsValidated = 0;
    let nbrOfCheckPointMandatory = 0;
    let nbrOfCheckPointMandatoryValidated = 0;
    for (const process of store.state.taskModule.gatheringProcessOrder) {
        let nbrOfCheckPoint = 0;
        let nbrOfCheckPointValidated = 0;
        let nbrOfCheckPointNotValidated = 0;
         nbrOfCheckPointMandatory = 0;
         nbrOfCheckPointMandatoryValidated = 0;
        if (process.resourceUid === resourceUid) {
            if (process.checkpoints[index].status) {
                process.checkpoints[index].status.resourceUid = status

                process.checkpoints[index].completionDate = moment().format('YYYY-MM-DD HH:mm:ss');
                const fieldValue = deepClone(process.checkpoints[index])
                delete fieldValue.whoModified
                fieldValue.status = {
                    resourceUid: fieldValue.status.resourceUid,
                    objectType: fieldValue.status.objectType,
                    systemUid: fieldValue.status.systemUid
                };
                fieldValue.checkPointsConfig = {
                    resourceUid: fieldValue.checkPointsConfig.resourceUid,
                    objectType: fieldValue.checkPointsConfig.objectType,
                    systemUid: fieldValue.checkPointsConfig.systemUid
                };
                store.dispatch("taskModule/updateCheckPointsStatus", {
                    request: fieldValue,
                });
            }
            const authName= store.getters["authModule/getAuthName"];
            process.checkpoints[index].whoModified = authName
        }

        for (const items of process.checkpoints) {
            if( items.objectType.includes('businessrulevalue')){
                nbrOfMandatoryDocuments++
                if (items.status.resourceUid === 'COMPLETED') {
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                    nbrOfMandatoryDocumentsValidated++
                    nbrOfCheckPointMandatory++
                    nbrOfCheckPointMandatoryValidated++
                } else {
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                    nbrOfCheckPointMandatory++
                }
            }else{
                if( items.objectType.includes('documentvalue')){
                    for(const doc of items.documents){
                        if (doc.mandatory) {
                            nbrOfMandatoryDocuments++
                            nbrOfCheckPointMandatory++
                            if (doc.status === 'QUALIFIED' || doc.status === 'IN_PROGRESS'  || doc.status === 'OVERWRITE' || doc.status === 'VALID'  || doc.status === 'SIGNED') {
                                nbrOfMandatoryDocumentsValidated++
                                nbrOfCheckPointMandatoryValidated++
                            }
                        }
                        if(doc.documentUpload && doc.documentUpload.originalFileName ){
                            nbrOfCheckPoint++
                            nbrOfCheckPointValidated++
                        }else{
                            nbrOfCheckPoint++
                            nbrOfCheckPointNotValidated++
                        }
                    }

                }else{
                    nbrOfMandatoryDocuments++
                    if (items.status && items.status.resourceUid === 'COMPLETED') {
                        nbrOfCheckPoint++
                        nbrOfCheckPointValidated++
                        nbrOfMandatoryDocumentsValidated++
                        nbrOfCheckPointMandatory++
                        nbrOfCheckPointMandatoryValidated++
                    } else {
                        nbrOfCheckPoint++
                        nbrOfCheckPointNotValidated++
                        nbrOfCheckPointMandatory++
                    }

                }
            }

        }
        process.nbrReceivedItems = nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint
        process.nbrValidatedItems = nbrOfCheckPointValidated + '/' + nbrOfCheckPoint
         if (nbrOfCheckPointMandatoryValidated === nbrOfCheckPointMandatory) {
            process.status = "COMPLETED"
        }
        else {
            process.status = "PROCESSING"
        }
    }
    if (nbrOfMandatoryDocumentsValidated === nbrOfMandatoryDocuments) {
        store.dispatch('orderModule/setPreConditionValid', true)
    } else {
        store.dispatch('orderModule/setPreConditionValid', false);
    }
    // Mirror updated list to orderModule
    store.dispatch("orderModule/gatheringProcessOrder", {
        request: { gatheringProcess: store.state.taskModule.gatheringProcessOrder },
    }).catch(e => console.error(e));
}
 export async function processOrderMass(listOrder :any){
    const env = connectedUserconfigurationEnv()
    const list :any =[]
    if(listOrder.length&&listOrder.length>0){
        for(const orderid of listOrder){
            if(orderid.variables&&orderid.variables.orderId &&orderid.variables.orderId.value){
                const order = await getGatheringProcessFromOrder(orderid.variables.orderId.value)
                if(order && order.length && order.length>0){
                    for(const orderGatheringProcess of order){
                        if(orderGatheringProcess.gatheringProcess &&orderGatheringProcess.gatheringProcess.resourceUid){
                           const requiredDocuments= await getRequiredDocumentValidatedByBR(orderGatheringProcess.gatheringProcess.resourceUid,orderid.variables.orderId.value)
                           const process =await getProcess(orderGatheringProcess.gatheringProcess.resourceUid)
                           const listOfOrderMass = await processDocumentsOrderMass({
                            gatheringProcess: process,
                            requiredDocuments: requiredDocuments,
                            supportingDocuments: process.supportingDocuments,
                            receivedFiles: process.gatheringProcessItem[0].receivedFiles,
                            orderReference:orderid.variables?.orderReference?.value,
                            orderId:orderid.variables?.orderId?.value
                          })

                        // Determine whether the order's assessment context is allowed for this task
                        const mapping: any =  env === 'BODEMER'
                                            ? taskCOMPLETEPRECONDITIONSMapping
                                            : env === 'GEMY'? taskCOMPLETEPRECONDITIONSMappingGEMY
                                            : {};
                        const taskDefinition = orderid.taskDefinition as keyof typeof mapping;
                        const allowedContexts = mapping[taskDefinition] || [];

                        const assessmentContext = listOfOrderMass?.assessmentContext;
                        // If mapping is empty treat as permissive (don't filter out items)
                        const isAllowed = !allowedContexts || allowedContexts.length === 0 || (assessmentContext && allowedContexts.includes(assessmentContext));
                        const isDuplicate = list.some((item: any) =>
                            item.assessmentContext === assessmentContext && item.orderReference === listOfOrderMass.orderReference
                        );

                        // Only add when the context is allowed and it's not already in the list
                        if (isAllowed && !isDuplicate) {
                            list.push(listOfOrderMass);
                        }

                        }

                    }

                }

            }
        }
    }

    return list

}
export const processDocumentsOrderMass = async (payload: {
    gatheringProcess: any,
    requiredDocuments: any,
    supportingDocuments: any[],
    receivedFiles: any[],
    orderReference:any,
    orderId:any
}) => {

    const {
        gatheringProcess,
        requiredDocuments,
        supportingDocuments,
        receivedFiles,
        orderReference,
        orderId
    } = payload;

    const deleteManualDocs: any[] = [];
    const nbrDeleteManualDocs = deleteManualDocs.length ? deleteManualDocs.length : 0
    const listOfCheckpoints: any[] = []
    let nbrOfCheckPoint = 0;
    let nbrOfCheckPointValidated = 0;
    let nbrOfCheckPointNotValidated = 0;

    for (const requiredDocument of requiredDocuments){
            if(gatheringProcess.supportingDocuments.length===1){
                requiredDocument.supportingDocumentUid =gatheringProcess.supportingDocuments[0]?.resourceUid
            }else{
                const supportingDocument = gatheringProcess.supportingDocuments.find((s: any) =>
                    requiredDocument.supportingType?.some((st: any) =>
                        st.supportingDocument?.resourceUid === s.documentFamily?.resourceUid
                    )
                );
                if(!requiredDocument.supportingDocumentUid && supportingDocument){
                requiredDocument.supportingDocumentUid =supportingDocument?.resourceUid
                }
            }
        }
        for (const items of gatheringProcess.gatheringProcessItem[0].items) {
            const ListOfDocuments = []
            if(items.objectType.includes('documentvalue')){
                const supDocumentsFiltered = supportingDocuments.filter((s: any) => s?.resourceUid === items.supportingDocument?.resourceUid)[0];
            if (supDocumentsFiltered) {
                for (const document of requiredDocuments) {
                    let documentUpload = {};
                    let creationDate = "";
                    let creationUser ="";
                    let status = "";
                    let comment = "";
                    let receivedFilesUid = "";
                    const doc = gatheringProcess.gatheringProcessItem[0].receivedFiles.filter(
                        (s: any) => s.content[0]?.documentType?.resourceUid === document?.resourceUid
                    );
                    if ( doc.length > 0 ) {
                        documentUpload = {
                            format: "",
                            originalFileName: doc[doc.length - 1].content[0].label,
                            resourceUid: doc[doc.length - 1].fileReference?.resourceUid,
                            objectType: doc[doc.length - 1].fileReference?.objectType,
                            systemUid: doc[doc.length - 1].fileReference?.systemUid,
                        };
                        creationDate = doc[doc.length - 1].receptionDate;
                        creationUser = doc[doc.length - 1].creationUser;
                        status = doc[doc.length - 1].content[0].status?.resourceUid;
                        comment = doc[doc.length - 1].content[0].label;
                        receivedFilesUid = doc[doc.length - 1]?.resourceUid;


                    }

                    if(document.supportingDocumentUid===items.supportingDocument?.resourceUid){
                         const supportingTypeMatched = document.supportingType?.find((st: any) =>
                            st.supportingDocument?.resourceUid === supDocumentsFiltered?.documentFamily?.resourceUid
                        );
                        ListOfDocuments.push({
                            documentUpload: documentUpload,
                            creationDate: creationDate,
                            status: status,
                            comment: comment,
                            typeJustify: supportingTypeMatched?.supportingDocument?.resourceUid,
                            documentType: document.resourceUid,
                            toBeSigned: supportingTypeMatched?.toBeSigned ?? false,
                            processResourceUid: gatheringProcess?.resourceUid,
                            receivedFilesUid: receivedFilesUid,
                            // Statuts declencheurs du versement en coffre, portes par le
                            // supportingType. Les deux autres constructeurs de lignes les
                            // emettaient deja ; leur absence ici privait la GED de
                            // l'affordance de versement, sans erreur ni trace.
                            documentStatus: supportingTypeMatched?.documentStatus,
                            esignProcessId: doc.length > 0 ? doc[doc.length - 1].businessData?.esignProcessId : undefined,
                        })
                    }




                }
                items.documents = ListOfDocuments
                listOfCheckpoints.push(items)

            }
            for(const doc of items.documents || []){
                if(doc.documentUpload && doc.documentUpload.originalFileName ){
                    nbrOfCheckPoint++
                    nbrOfCheckPointValidated++
                }else{
                    nbrOfCheckPoint++
                    nbrOfCheckPointNotValidated++
                }
            }
        }
    }

    const gatheringProcessOrder={
        resourceUid: gatheringProcess?.resourceUid,
        nbrReceivedItems: nbrOfCheckPointNotValidated + '/' + nbrOfCheckPoint,
        nbrValidatedItems: nbrOfCheckPointValidated + '/' + nbrOfCheckPoint,
        status: gatheringProcess.status?.resourceUid,
        assessmentContext: gatheringProcess.contextType.rawValue,
        orderReference:orderReference,
        orderId:orderId,
        checkpoints: listOfCheckpoints
    }

    return gatheringProcessOrder



}
export async function UploadDocumentMass(files: any, resourceUid: any, childId: any,index:any, filePanelIndex?:any) {
    for (const process of store.state.taskModule.UploadDocumentsMass) {
        if (process.resourceUid === resourceUid) {
            const documentItem = process.checkpoints[childId]
            if (documentItem) {
                documentItem.documents[index].documentUpload = files[0];
                if (documentItem.documents && documentItem.documents[index].documentUpload) {
                    await store.dispatch("taskModule/uploadDocumentModule/setUploadDocumentLoading",
                        {
                            "status": true,
                            "loadingIndex": `${resourceUid}_${childId}_${index}`
                        }
                    )
                    getBase64(documentItem.documents[index].documentUpload).then((base64) => {
                        const fileContent: FileContent = {
                            originalFileName: documentItem.documents[index].documentUpload.name,
                            format: 'application/pdf',
                            content: base64,
                            relations: {
                                items: [
                                    {
                                        qualifier: {
                                            rawValue: documentItem.documents[index]?.documentType,
                                        },
                                        objectUON: {
                                            objectType: "odm.filemngt.filecontent",
                                            systemUid: UON.SystemUid.odmFileManagement,
                                        },
                                    },
                                ],
                            },
                        };


                        store.dispatch("taskModule/uploadDocumentModule/uploadFile", {
                            request: fileContent,
                            documentType: documentItem.documents[index]?.documentType,
                            processid: process.resourceUid,
                            filePanelIndex: filePanelIndex ?? undefined,
                            callback: (response: FileContent) =>
                                handleDocumentMassResponse(response, resourceUid, childId,index),
                        });
                    });


                } else {
                    Notify.create({
                        color: "negative",
                        message: "Erreur!",
                    });
                }
            }

        }
    }
}
export async function handleDocumentMassResponse(response: FileContent, resourceUid: any, childId: number,index: number) {
    for (const process of store.state.taskModule.UploadDocumentsMass) {
        if (process.resourceUid === resourceUid) {
            const authName= store.getters["authModule/getAuthName"];
            process.checkpoints[childId].documents[index].documentUpload = response || {};
            process.checkpoints[childId].documents[index].creationDate = moment(new Date()).format("DD/MM/YYYY");
            process.checkpoints[childId].documents[index].status = 'QUALIFIED';
            process.checkpoints[childId].documents[index].comment = response.originalFileName;
            process.checkpoints[childId].whoModified = authName
            process.checkpoints[childId].status.resourceUid = 'COMPLETED'
            const documentValue = deepClone(process.checkpoints[childId])
            delete documentValue.documents
            delete documentValue.whoModified
            delete documentValue.creationDate
            const IsValid=process.checkpoints[childId].documents.filter((s: any) =>
            s.status !== 'QUALIFIED');
            if(IsValid.length===0){
                store.dispatch("taskModule/updateDocumentValue", {
                    request: documentValue,
                });
            }

        }
    }

}

export function removeItemMass(resourceUid: any, i: number,index: number) {
    store.dispatch('orderModule/setPreConditionValid', false)
    for (const process of store.state.taskModule.UploadDocumentsMass) {
        if (process.resourceUid === resourceUid) {
            process.checkpoints[i].documents[index].documentUpload = {}
            process.checkpoints[i].documents[index].status = "PENDING";
            process.checkpoints[i].documents[index].receivedFilesUid = "";
            process.checkpoints[i].documents[index].creationDate = "";
            process.checkpoints[i].documents[index].comment = "";
            process.checkpoints[i].documents[index].whoModified = "";
            if (process.checkpoints[i].objectType?.includes('documentvalue')) {
                process.checkpoints[i].document = deepClone(process.checkpoints[i].documents[index]);
            }
            if (process.checkpoints[i].status) {
                const authName= store.getters["authModule/getAuthName"];
                process.checkpoints[i].status.resourceUid = 'PENDING'
                process.checkpoints[i].whoModified = authName
                const documentValue = deepClone(process.checkpoints[i])
                delete documentValue.documents
                delete documentValue.whoModified
                delete documentValue.creationDate

                store.dispatch("taskModule/updateDocumentValue", {
                    request: documentValue,
                });
            }
        }
        process.status = "PROCESSING"
    }
}

export async function moveDocuments(payload :any){
    const {
        processId,
        processItemsId,
        receivedFilesUid,
        checkPointDoc,
        orders
    } = payload;

    if(processId && processItemsId &&receivedFilesUid && orders && orders.length && orders.length>0){
        for(const order of orders){

            if(order.process_id && order.process_item_id){
                const body={
                    newProcessId:order.process_id,
                    newDocumentId:order.process_item_id
                    }
                const result = await moveDocument(processId,processItemsId,receivedFilesUid,body)
                 if (result){
                        await removeReceivedFile(processId,receivedFilesUid)
                        const document = checkPointDoc && checkPointDoc.document ? checkPointDoc.document : undefined

                        const documentType = document?.documentType
                            store.dispatch("taskModule/uploadDocumentModule/process", {
                                    processid: processId,
                                    callback: (response: any) =>
                                    {
                                        const receivedFiles = response.gatheringProcessItem
                                                              && response.gatheringProcessItem[0]
                                                              && response.gatheringProcessItem[0].receivedFiles
                                                              ? response.gatheringProcessItem[0].receivedFiles
                                                              : []

                                        const file  = receivedFiles
                                                      ?.find((file:any) =>file.content?.some((item:any) => item.documentType && item.documentType?.resourceUid === documentType));
                                         if (!file){
                                            checkPointDoc.receivedFilesUid = ""
                                            checkPointDoc.creationDate = ""
                                            checkPointDoc.whoModified = ""
                                            document.documentUpload = {}
                                            document.creationDate = ""
                                            document.status = "PENDING"
                                            document.comment = ""
                                            document.receivedFilesUid = ""
                                            document.whoModified = ""
                                            document.whenModified = ""
                                         }

                                    }
                            });
                    }

            }

        }



            if (checkPointDoc.checkPointsConfig){
                deleteNonRequiredAttributes(checkPointDoc.checkPointsConfig, ["objectType", "resourceUid", "systemUid"]);
            }
            if (checkPointDoc.supportingDocument){
                deleteNonRequiredAttributes(checkPointDoc.supportingDocument, ["objectType", "resourceUid", "systemUid"]);
            }

            if (checkPointDoc.status) {
                const authName= store.getters["authModule/getAuthName"];
                checkPointDoc.status.resourceUid = 'PENDING'
                deleteNonRequiredAttributes(checkPointDoc.status, ["objectType", "resourceUid", "system_uid"]);
                checkPointDoc.whoModified = authName
                const documentValue = deepClone(checkPointDoc)
                delete documentValue.document
                delete documentValue.documents
                delete documentValue.whoModified
                delete documentValue.creationDate
                delete documentValue.processId
                delete documentValue.processItemsId
                delete documentValue.receivedFilesUid


                store.dispatch("taskModule/updateDocumentValue", {
                        request: documentValue,
                    });
            }


        //remove for the original place

    }

}
export async function changeDocument(documentFrom: any, documentTo: any) {
    // Support both single-object and array payloads coming from the dialog
    const targetDocument = Array.isArray(documentTo) ? documentTo[0] : documentTo;

    if (!targetDocument || !targetDocument.config) {
        return;
    }

    // Only process once - move document from specific source to specific target
    if (documentFrom.document &&
        documentFrom.document.documentUpload &&
        documentFrom.document.documentUpload.resourceUid) {

        const doc = await downloadFile(documentFrom.document.documentUpload.resourceUid);

        const targetDocumentType = targetDocument.config?.documentType;
        const targetProcessId = targetDocument.config?.processResourceUid;
        const fileContent: FileContent = {
            originalFileName: doc.originalFileName,
            format: doc.format,
            content: doc.content,
            relations: {
                items: [
                    {
                        qualifier: {
                            rawValue: targetDocumentType,
                        },
                        objectUON: {
                            objectType: "odm.filemngt.filecontent",
                            systemUid: UON.SystemUid.odmFileManagement,
                        },
                    },
                ],
            },
        };

        store.dispatch("taskModule/uploadDocumentModule/uploadFile", {
            request: fileContent,
            documentType: targetDocumentType,
            processid: targetProcessId,
            callback: async (response: FileContent) => {
                const authName = store.getters["authModule/getAuthName"];
                const now = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                const uploadStatus = response && response.isForcedDocument
                    ? "OVERWRITE"
                    : response && response.isCommentedDocument
                        ? "COMMENTED"
                        : "QUALIFIED";

                // Hydrate the target checkpoint so the document can be moved again later
                for (const process of store.state.taskModule.gatheringProcessOrder) {
                    if (process.resourceUid !== targetProcessId) {
                        continue;
                    }

                    for (const checkpoint of process.checkpoints || []) {
                        const matchesDocument =
                            (checkpoint.document && checkpoint.document.documentType === targetDocumentType) ||
                            (checkpoint.documents || []).some((d: any) => d.documentType === targetDocumentType);

                        if (!matchesDocument) {
                            continue;
                        }

                        const uploadDescriptor = response
                            ? {
                                originalFileName: response.originalFileName,
                                resourceUid: response.resourceUid,
                                objectType: response.objectType || "odm.filemngt.filedescriptor",
                                systemUid: response.systemUid || "odm-filemngt",
                                format: response.format,
                                nbrOfPages: (response as any)?.nbrOfPages
                              }
                            : {};

                        if (Array.isArray(checkpoint.documents) && checkpoint.documents.length) {
                            const docIndex = checkpoint.documents.findIndex((d: any) => d.documentType === targetDocumentType);
                            const currentDocIndex = docIndex !== -1 ? docIndex : 0;
                            const existingDoc = checkpoint.documents[currentDocIndex] || {};
                            const updatedDoc = {
                                ...existingDoc,
                                documentUpload: uploadDescriptor,
                                creationDate: now,
                                status: uploadStatus,
                                comment: response?.originalFileName,
                                receivedFilesUid: response?.receivedFilesUid,
                                whoModified: authName,
                                documentType: targetDocumentType,
                                processResourceUid: targetProcessId,
                                mandatory: targetDocument.config?.mandatory ?? existingDoc?.mandatory,
                                typeJustify: targetDocument.config?.typeJustify ?? existingDoc?.typeJustify,
                            };
                            checkpoint.documents[currentDocIndex] = updatedDoc;

                            if (checkpoint.objectType?.includes('documentvalue')) {
                                checkpoint.document = deepClone(updatedDoc);
                            }
                        } else if (checkpoint.objectType?.includes('documentvalue')) {
                            checkpoint.document = {
                                ...(checkpoint.document || {}),
                                documentUpload: uploadDescriptor,
                                creationDate: now,
                                status: uploadStatus,
                                comment: response?.originalFileName,
                                receivedFilesUid: response?.receivedFilesUid,
                                whoModified: authName,
                                documentType: targetDocumentType,
                                processResourceUid: targetProcessId,
                                mandatory: targetDocument.config?.mandatory ?? checkpoint.document?.mandatory,
                                typeJustify: targetDocument.config?.typeJustify ?? checkpoint.document?.typeJustify,
                            };
                        }

                        checkpoint.status = checkpoint.status || {};
                        if (checkpoint.status.resourceUid) {
                            checkpoint.status.resourceUid = "COMPLETED";
                        }
                        checkpoint.receivedFilesUid = response?.receivedFilesUid;
                        checkpoint.whoModified = authName;
                    }
                }

                // Delete the original file from documentFrom
                let fileIdToDelete = documentFrom.receivedFilesUid
                    || documentFrom.document?.receivedFilesUid
                    || (documentFrom.documents && documentFrom.documents[0]?.receivedFilesUid);

                if (fileIdToDelete && fileIdToDelete.trim() !== '') {
                    try {
                        await deleteReceivedFile(documentFrom.processId, fileIdToDelete);

                        // Clear the original checkpoint's document state
                        for (const process of store.state.orderModule.gatheringProcessOrder) {
                            for (const checkpoint of process.checkpoints) {
                                if (checkpoint.receivedFilesUid === fileIdToDelete) {
                                    checkpoint.receivedFilesUid = "";
                                    checkpoint.creationDate = "";
                                    checkpoint.whoModified = "";
                                    if (checkpoint.document) {
                                        checkpoint.document.documentUpload = {};
                                        checkpoint.document.creationDate = "";
                                        checkpoint.document.status = "PENDING";
                                        checkpoint.document.comment = "";
                                        checkpoint.document.receivedFilesUid = "";
                                        checkpoint.document.whoModified = "";
                                        checkpoint.document.whenModified = "";
                                    }
                                }
                            }
                        }
                    } catch (error: any) {
                        if (error?.response?.status !== 404) {
                            console.error('Error deleting file:', error);
                        }
                    }
                }
            }
        });
    }
}


async function compressPDF(file: File): Promise<File> {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const pdfDoc = await PDFDocument.create();

    for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 1.0 });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d')!;
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: context, viewport }).promise;

        const imageData = canvas.toDataURL('image/jpeg', 0.8); // compression à 70% qualité
        const jpgImage = await pdfDoc.embedJpg(imageData);
        const newPage = pdfDoc.addPage([jpgImage.width, jpgImage.height]);
        newPage.drawImage(jpgImage, {
            x: 0,
            y: 0,
            width: jpgImage.width,
            height: jpgImage.height,
        });
    }

    const compressedBytes = await pdfDoc.save();
    return new File([compressedBytes], file.name, { type: 'application/pdf' });
}

export function sortDocuments(listOfCheckpoints: any) {
    if (!listOfCheckpoints || !Array.isArray(listOfCheckpoints)) return [];

    return listOfCheckpoints.sort((a: any, b: any) => {

        const valA = a.document ? a.document.displayOrder : a.displayOrder;
        const valB = b.document ? b.document.displayOrder : b.displayOrder;

        const orderA = (valA !== null && valA !== undefined) ? valA : Infinity;
        const orderB = (valB !== null && valB !== undefined) ? valB : Infinity;

        return orderA - orderB;
    });
}


export function sortDocumentsInTasksDetail(listOfCheckpoints: any[]) {
    if (!listOfCheckpoints || !Array.isArray(listOfCheckpoints)) return [];

    return [...listOfCheckpoints].sort((a: any, b: any) => {
        // 1. On cherche la valeur de tri pour A
        // Priorité : displayOrder du 1er doc > checkOrder du checkpoint > displayOrder direct
        const valA = (a.documents && a.documents.length > 0)
            ? a.documents[0].displayOrder
            : (a.checkOrder ?? a.displayOrder);

        // 2. On cherche la valeur de tri pour B
        const valB = (b.documents && b.documents.length > 0)
            ? b.documents[0].displayOrder
            : (b.checkOrder ?? b.displayOrder);

        // 3. Gestion des ordres (null/undefined vont à la fin via Infinity)
        const orderA = (valA !== null && valA !== undefined) ? valA : Infinity;
        const orderB = (valB !== null && valB !== undefined) ? valB : Infinity;

        return orderA - orderB;
    });
}

/**
 * Validation IA des documents pilotée par la configuration `VUE_APP_IA`.
 * Seule la valeur "false" la désactive : variable absente ou vide = IA active, afin de ne pas
 * changer le comportement des environnements déjà déployés.
 */
export function isAiVerificationEnabled(): boolean {
    const flag = settings.AI.VUE_APP_IA;
    return flag === undefined || flag === null || String(flag).toLowerCase() !== 'false';
}

/**
 * Lance la validation IA d'un document en pilotant l'indicateur de chargement par-document
 * (`aiLoadingIndexes`), ce qui autorise plusieurs analyses en parallèle sans bloquer les autres
 * uploads. Renvoie `undefined` lorsque la fonctionnalité est désactivée par configuration : les
 * appelants retombent alors sur le comportement historique (statut "QUALIFIED", pas de commentaire IA).
 */
async function runAiVerification(
    document: File,
    documentType: string,
    aiLoadingIndex: string
): Promise<{ status: string; comments: string } | undefined> {
    if (!isAiVerificationEnabled()) {
        return undefined;
    }

    await store.dispatch("taskModule/uploadDocumentModule/setAiLoading", {
        loadingIndex: aiLoadingIndex,
        active: true,
        // Le nom est celui du fichier déposé : la ligne l'affiche pendant l'analyse, à la
        // place de la zone de dépôt qui n'a plus lieu d'être proposée.
        fileName: document?.name
    });

    try {
        // La vérification peut être longue (timeout 360s), d'où le spinner dédié au document.
        const docVerifResult = await launchDocumentVerification(document, documentType);
        // launchDocumentVerification renvoie { result: data } ; getStatutByAPIResponse tolère l'absence
        // de retour (timeout / erreur réseau) en basculant sur une relecture humaine.
        return getStatutByAPIResponse(docVerifResult?.result);
    } finally {
        // Fin de l'analyse IA de CE document uniquement (les autres analyses restent en cours).
        await store.dispatch("taskModule/uploadDocumentModule/setAiLoading", {
            loadingIndex: aiLoadingIndex,
            active: false
        });
    }
}

async function launchDocumentVerification(document: File, documentType: string) {

    const languageMapping: Record<string, string> = {
        "fr-FR": "Français",
        "en-US": "English (US)"
    };

   const language = i18n.global.locale.value.toString();

    const formData = new FormData();
    formData.append("file", document);
    formData.append("docType", documentType);
    formData.append("language", languageMapping[language]);

    /*
    Penser à mettre des spinners pour montrer le chargement
    Il faut mettre un filtre blanc transparent sur le site et désactiver tous les boutons
    Le nouveau Endpoint de l'API renverra un booleen qui dit si oui ou non le document est recevable.
        -> Le booléen sera à l'origine du status du document par la suite.
        -> Si le taux de confiance de l'API est trop bas, alors il faudra afficher une erreur.
    */

    const urlApi =`${settings.AI.VUE_APP_VERIF_DOCUMENT_LINK_API}/validate`;
    if (!urlApi) {
        throw new Error("La variable d'environnement VERIF_DOCUMENT_LINK_API n'est pas définie.");
    }

    const keyApi = settings.AI.VUE_APP_JWT_SECRET_KEY_VERIF_DOCUMENT_API;
    if (!keyApi) {
        throw new Error("La variable d'environnement JWT_SECRET_KEY_VERIF_DOCUMENT_API n'est pas définie.");
    }

    const token = await createJWTToken(keyApi, 'api:python', 'python-api');

    try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 360_000);


        const response = await fetch(
            urlApi,
            {
                method:'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
                signal: controller.signal,
            }
        )

        if (response.status === 415) {
            throw new Error("Filetype is not supported. Please make sure to put only .PNG or .PDF file");
        }

        if (!response.ok) {
            throw new Error(`Error with api: ${response.status}`)
        }

        const data = await response.json();

        clearTimeout(timeout);

        return {
            result: data
        };

    }
    catch (error) {
        console.log(error);
    }
}

async function createJWTToken(key: string, scope: string, aud: string) {
    const secret = new TextEncoder().encode(key);
    const now = Math.floor(Date.now() / 1000) - 30;

    return await new SignJWT({ scope, iss: 'eflo-disrib', aud })
        .setProtectedHeader({ alg: 'HS256' })
        .setIssuedAt(now)
        .setExpirationTime(now + 60 * 5)
        .sign(secret);
}


export function getStatutByAPIResponse(data: any): { status: string; comments: string } {
    // Aucun retour exploitable de l'IA -> relecture humaine
    if (!data) {
        return { status: "HUMAN_REVIEW", comments: "" };
    }

    let status = "PENDING";
    let comments = "";

    if (data.confidence <= 0.8 || (data.is_complete === false && data.is_valid === false) || !data.is_valid) {
        // Confiance trop faible / document incomplet / invalide -> relecture humaine
        status = "HUMAN_REVIEW";
        comments = buildAiComment(data);
    } else if (data.is_complete && data.is_valid) {
        // Document complet et valide -> validé par l'IA
        status = "VALID";
    }

    return { status, comments };
}

/**
 * Construit un commentaire structuré et lisible à partir du retour de l'IA :
 * une entête "Analyse IA", un titre pour les problèmes (issues) et un titre pour
 * les champs manquants (missing_fields), chaque élément étant présenté en puce.
 * Format multi-lignes (séparateur "\n") exploité par le rendu en liste des tooltips.
 */
function buildAiComment(data: any): string {
    const issuesList = (Array.isArray(data?.issues) ? data.issues : []).flat().filter((x: any) => !!x);
    const missingList = (Array.isArray(data?.missing_fields) ? data.missing_fields : []).flat().filter((x: any) => !!x);
    if (issuesList.length === 0 && missingList.length === 0) {
        return "";
    }
    const t = (key: string) => i18n.global.t(`order.preconditions.documents.aiVerification.${key}`) as string;
    const lines: string[] = [t("commentHeader")];
    if (issuesList.length > 0) {
        lines.push(`${t("issuesTitle")} :`);
        issuesList.forEach((issue: string) => lines.push(`• ${issue}`));
    }
    if (missingList.length > 0) {
        lines.push(`${t("missingFieldsTitle")} :`);
        missingList.forEach((field: string) => lines.push(`• ${field}`));
    }
    return lines.join("\n");
}
